export const STATE_NEW = "NEW";
export const STATE_DELETED = "DELETED";
export const STATE_EDITED = "EDITED";
export const STATE_CHECKING = "CHECKING_URL";
export const STATE_VALIDATED = "VALIDATED";
